import { BenArr } from '@/common/BenArr'
import { BenDate } from '@/common/BenDate'
import { BenFn } from '@/common/BenFn'
import { BenHttp } from '@/common/BenHttp'
import { BenLocalStore } from '@/common/BenLocalStore'
import { BenQuery } from '@/js/BenQuery'
import { BenView } from '@/js/BenView'
const ST = { customer_id: null, last_id: 0, isFirstTime: true, storeType: 'session' as 'session' | 'local', timer: 0, pid: '' }
const CT = { queryDistance: 5000 }

export class WimFn {
  static init() {
    ST.pid = _getRandomStr(4) + `-${window.innerWidth}-${window.innerHeight}`
    const id = BenLocalStore.get('customer_id', { type: 'local' })
    if (id !== null) {
      ST.customer_id = id || ''
      ST.storeType = 'local'
    } else {
      ST.customer_id = BenLocalStore.get('customer_id') || ''
    }
    let messages = BenLocalStore.get('messages', { type: ST.storeType }) || []
    const replys = messages.filter((item) => item.is_reply === 1)
    if (replys.length) {
      const lastItem = BenArr.getLastItem(replys) as any
      ST.last_id = lastItem.id
    }
    let unread = BenLocalStore.get('unread', { type: ST.storeType }) || 0
    const cookieOption = BenLocalStore.get('acceptCookie', { type: ST.storeType })
    if (messages.length === 0) {
      messages = [{ message: BenQuery.getWinValue('sayHi') }]
      unread = 1
    }
    return { messages, unread, cookieOption }
  }

  static onStoreChange(onUnreadChange, onMessagesChange, onCookieAcceptChange) {
    window.addEventListener('storage', async ({ key, newValue }) => {
      const newValueParse = JSON.parse(newValue!)
      if (key === 'messages') {
        let last_id = 0
        for (const item of newValueParse || []) {
          if (item.last_id !== void 0) last_id = item.last_id
        }
        ST.last_id = last_id
        onMessagesChange(newValueParse)
      } else if (key === 'acceptCookie') {
        if (newValueParse === true) {
          ST.storeType = 'local'
          BenLocalStore.clear({ type: 'session' })
          onCookieAcceptChange(true)
        }
      } else if (key === 'unread') {
        onUnreadChange(newValueParse)
      } else if (key === 'queryStamp') {
      } else if (key === 'customer_id') {
        ST.customer_id = newValueParse
      }
    })
  }

  static async cookieAccpet() {
    ST.storeType = 'local'
    BenLocalStore.copySessionToLocal({ clear: true })
    BenLocalStore.set('acceptCookie', true, { type: ST.storeType })
    await WimFn.sendMessage('#ACCEPT')
  }

  static async cookieReject() {
    ST.storeType = 'session'
    BenLocalStore.copyLocalToSession({ clear: true })
    BenLocalStore.set('acceptCookie', false, { type: ST.storeType })
    await WimFn.sendMessage('#REJECT')
  }

  static needToShowCookieAccept() {
    if (ST.storeType === 'local') return false
    const bool = BenLocalStore.get('acceptCookie')
    if (bool === false) return false
    return true
  }

  static updateStoreList(data) {
    BenLocalStore.set('messages', data, { type: ST.storeType })
  }

  static updateUnread(count) {
    BenLocalStore.set('unread', count, { type: ST.storeType })
  }

  static getStoreList() {
    const messages = BenLocalStore.get('messages', { type: ST.storeType })
    return messages || []
  }

  static sendBeanconToReplyApi() {
    const url = _getUrl('/get-reply')
    const neededData = BenFn.clone(_getReplyNeededData())
    const data = JSON.stringify({ ...neededData, url: neededData.land_url })
    const blob = new Blob([data], { type: 'application/json' })
    navigator.sendBeacon(url, blob)
  }

  static onMessageReply(callback) {
    const url = _getUrl('/get-reply')
    let isHidden = !!document.hidden
    document.addEventListener('visibilitychange', () => {
      isHidden = !!document.hidden
    })
    const query = async () => {
      clearTimeout(ST.timer)
      if (ST.isFirstTime === false && isHidden) {
        ST.timer = setTimeout(query, CT.queryDistance)
        return
      }
      let ref = undefined as any
      if (ST.isFirstTime === true) {
        ref = document.referrer || 'EMPTY'
      }
      const { land_url, token, last_id, customer_id, pid } = _getReplyNeededData()
      try {
        const rs = await BenHttp.request(url, { customer_id, last_id, ref, url: land_url, token, pid })
        if (ST.isFirstTime === true) ST.isFirstTime = false
        const messages = rs.list || []
        const lastItem = messages.length > 0 ? BenArr.getLastItem(messages) : null
        //第一次，或服务器删库
        if (customer_id === '' || rs.customer_id !== customer_id) {
          ST.customer_id = rs.customer_id
          BenLocalStore.set('customer_id', rs.customer_id, { type: ST.storeType })
        } else {
          if (lastItem !== null) {
            ST.last_id = lastItem!['id']
            callback(messages)
          }
        }
      } catch (error) {}
      ST.timer = setTimeout(query, CT.queryDistance)
    }
    query()
  }

  static updateMessageListAfterSendSuccess(list, message) {
    const item = { message, $isCustomer: true }
    return [...list, item]
  }

  static async sendMessage(message: string) {
    const customer_id = ST.customer_id || ''
    const url = _getUrl('/send-message')
    try {
      return await BenHttp.request(url, { message, customer_id })
    } catch (error) {
      return false
    }
  }

  static async addTrack(key: 'VideoPlay' | 'VideoClose' | 'OpenSource' | 'ShowChat' | 'CloseChat', data: Record<string, any> = {}) {
    const map = {
      OpenSource: 'source-exist',
      VideoPlay: 'video-count',
      VideoClose: 'video-release',
      ShowChat: 'mes-new',
      CloseChat: 'mes-unset',
    }
    const action = map[key] || 'aaa'
    const url = _getUrl(`/${action}`)
    if (action === 'mes-new' || action === 'mes-unset') data = { id: ST.customer_id || '' }
    return await BenHttp.request(url, data)
  }
}

function _getUrl(url) {
  const env = BenQuery.getWinValue('env')
  const host = env === 'dev' ? '//127.0.0.1:3000' : ''
  return host + `/api` + url
}

function _getReplyNeededData() {
  const token = BenView.getToken()
  const pid = ST.pid
  const land_url = BenView.getLandUrl() || window.location.href
  const last_id = ST.last_id || 0
  const customer_id = ST.customer_id || ''
  return { land_url, token, last_id, customer_id, pid }
}

function _getRandomStr(len) {
  const chars = 'abcdefghijklmnopqrstuvwxyz0123456789'
  let result = ''
  for (let i = 0; i < len; i++) {
    const idx = Math.floor(Math.random() * chars.length)
    result += chars[idx]
  }
  return result
}
